import { isNuxt4Route } from '~/shared/const/app-routes'

/**
 * Реестр зон общего хоста: разделы, которые обслуживает новый фронт.
 * Единственный источник - OctoberCMS; реестр наполняется один раз
 * за SSR-рендер и приходит клиенту в payload. Клиент не рефетчит:
 * границу зон пересекают только полной перезагрузкой, она же обновляет реестр.
 *
 * @see ~/plugins/app-zones.server.ts - единственная точка записи `prefixes`
 * @see ~/shared/const/app-routes.ts - семантика совпадения префиксов
 */
export const useAppZones = () => {
  const prefixes = useState<ReadonlyArray<string>>('app-zones-prefixes', () => [])

  return {
    prefixes,
    /** Свои URL (разделы реестра) - SPA-переход, чужие - <a href>. */
    isOwnRoute: (url: string): boolean => isNuxt4Route(url, prefixes.value),
  }
}
